import { KeyboardEvent, useRef, useState } from 'react'
import { InputWidth } from '../../../../../../../types/aoraki/input-width-types'
import { Button, FormField, TextInput } from '@msaf/core-react'

export interface GoToControlProps {
  setPage: (page: number) => void
  isSkeleton?: boolean
}

export default function GoToControl({ setPage, isSkeleton }: GoToControlProps) {
  const [inputValue, setInputValue] = useState<string>('')
  const buttonEl = useRef<HTMLButtonElement>(null)

  const updatePageNumber = () => {
    const pageNum = parseInt(inputValue)
    if (!isNaN(pageNum)) {
      setPage(pageNum)
      setInputValue('')
    }
  }

  // On enter within input, go to page entered
  // Note: due to internal behaviour of TextInput component, we have to force a blur to get current state of input
  // TODO: make ^ less gross?
  const handleKeyboardSubmit = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') return
    buttonEl.current?.focus() // force blur event to update internal state of input
    buttonEl.current?.click()
  }

  return (
    <FormField label='Go to page' htmlFor='go-to-control' hasInputWithButton hasInlineLabel isSkeleton={isSkeleton}>
      <TextInput
        type='text'
        fieldSize={InputWidth.tiny}
        id='go-to-control'
        value={inputValue}
        setValue={setInputValue}
        isSkeleton={isSkeleton}
        onKeyDown={handleKeyboardSubmit}
      />
      <Button ref={buttonEl} label='Go' buttonStyle='secondary' onClick={updatePageNumber} isSkeleton={isSkeleton} />
    </FormField>
  )
}
